<ng-container [ngSwitch]="!!header">
  <!-- Render the form inside p-fieldset when header is provided -->
  <p-fieldset *ngSwitchCase="true" [legend]="header" class="w-full" styleClass="p-1">
    <ng-container *ngTemplateOutlet="addressFormTemplate"></ng-container>
  </p-fieldset>

  <!-- Render the form directly when header is not provided -->
  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="addressFormTemplate"></ng-container>
  </ng-container>
</ng-container>

<!-- Template containing the form structure -->
<ng-template #addressFormTemplate>
  <div class="flex">
    <div [formGroup]="addressForm" class="flex flex-column gap-3 w-full">
      <div class="flex gap-3">
        <span class="p-float-label flex-grow-1">
          <input
            (blur)="onTouched(addressForm.value)"
            [class.ng-invalid]="!!formValidCustom"
            formControlName="streetName"
            id="{{ field ? field.field + '-street' : ('float-input' | lowercase) }}"
            type="text"
            class="input-field"
            pInputText
            [jmlAutoSelect]="autoSelect"
          />
          <label for="float-input">Straße</label>
        </span>
        <span class="p-float-label w-5rem">
          <input
            (blur)="onTouched(addressForm.value)"
            [class.ng-invalid]="!!formValidCustom"
            formControlName="houseNumber"
            id="{{ field ? field.field + '-number' : ('float-input' | lowercase) }}"
            type="text"
            class="input-field"
            pInputText
            [jmlAutoSelect]="autoSelect"
          />
          <label for="float-input">Nr.</label>
        </span>
      </div>

      <div class="flex gap-3">
        <span class="p-float-label w-5rem">
          <input
            (blur)="onTouched(addressForm.value)"
            [class.ng-invalid]="!!formValidCustom"
            formControlName="zipCode"
            id="{{ field ? field.field + '-zip' : ('float-input' | lowercase) }}"
            type="text"
            class="input-field"
            pInputText
            [jmlAutoSelect]="autoSelect"
          />
          <label for="float-input">PLZ</label>
        </span>
        <span class="p-float-label flex-grow-1">
          <input
            (blur)="onTouched(addressForm.value)"
            [class.ng-invalid]="!!formValidCustom"
            formControlName="city"
            id="{{ field ? field.field + '-city' : ('float-input' | lowercase) }}"
            type="text"
            class="input-field"
            pInputText
            [jmlAutoSelect]="autoSelect"
          />
          <label for="float-input">Stadt</label>
        </span>
      </div>

      <p-dropdown
        [options]="countries"
        [class.ng-invalid]="!!formValidCustom"
        formControlName="countryId"
        [style]="{ width: '200px' }"
        placeholder="Land"
      >
      </p-dropdown>
    </div>
    <ng-content></ng-content>
  </div>
</ng-template>
